import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';

export const anonymisationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAnonymisationLogs: build.query<Response<any>, string>({
      query: (query) => ({
        url: `/v1/reports/anonymize-logs${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const { useLazyGetAnonymisationLogsQuery } = anonymisationApi;

export const {
  endpoints: { getAnonymisationLogs },
} = anonymisationApi;
